import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ValentineThemeService {
  private readonly _isActive = new BehaviorSubject<boolean>(false);
  readonly isActive$ = this._isActive.asObservable();

  private readonly _particlesVisible = new BehaviorSubject<boolean>(true);
  readonly particlesVisible$ = this._particlesVisible.asObservable();

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.checkThemeActivation();
  }

  hideParticles(): void {
    this._particlesVisible.next(false);
  }

  showParticles(): void {
    this._particlesVisible.next(true);
  }

  private checkThemeActivation(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const config = environment.valentine;
    if (!config || !config.enabled) {
      this._isActive.next(false);
      return;
    }

    const now = new Date();
    const start = new Date(config.startDate);
    const end = new Date(config.endDate);
    
    // Check if current time is within the theme window
    const shouldActivate = now >= start && now < end;
    
    // Toggle body class
    if (shouldActivate) {
      document.body.classList.add('valentine-theme');
    } else {
      document.body.classList.remove('valentine-theme');
    }
    
    this._isActive.next(shouldActivate);
    
    if (shouldActivate) {
      console.log('💕 Valentine Theme Activated 💕');
    }
  }

  // Helper to manually toggle for testing
  public toggleTheme(forceState?: boolean): void {
    const newState = forceState !== undefined ? forceState : !this._isActive.value;
    
    if (newState) {
      document.body.classList.add('valentine-theme');
    } else {
      document.body.classList.remove('valentine-theme');
    }
    
    this._isActive.next(newState);
  }
}
